import { Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class TableStateService {
  saveState(screen: string, userId: string, state: any) {
    const wrapper = {
      // timestamp: Date.now(),
      state
    };
    localStorage.setItem(`agilelegal_${screen}_${userId}`, JSON.stringify(wrapper));
  }

  getState(screen: string, userId: string): any {
    const data = localStorage.getItem(`agilelegal_${screen}_${userId}`);
    if (!data) return null;
    const wrapper = JSON.parse(data);
    // const now = Date.now();
    // // 24 hours = 86,400,000 ms
    // if (now - wrapper.timestamp > 86400000) {
    //   this.clearState(screen, userId);
    //   return null;
    // }
    return wrapper.state;
  }

  clearState(screen: string, userId: string) {
    localStorage.removeItem(`agilelegal_${screen}_${userId}`);
  }
}

export interface SavedTableState {
  event: LazyLoadEvent;
  customFilters: any;
}
